import React from 'react';

export const MissionReady = () => {
  return (
    <section className="mrm1-mission-section">
      <div className="mrm2-mission-content-wrapper">
        <div className="mrm2-mission-text mrm1-mission-text-override">
          <h2 className="mrm2-mission-title">
            <span className="mrm2-mission-title-span">TACTICAL</span>{' '}
            <span className="mrm2-mission-title-span">TOUGHNESS</span>
          </h2>
          <p className="mrm2-mission-description">
            The <span style={{ whiteSpace: 'nowrap' }}>MRM1-5</span> is
            specifically built to withstand the rigors of intense training and
            close-quarter operations. Its airframe is reinforced with four
            carbon fibre braces, creating an exceptionally durable platform that
            minimises downtime and maximises operator confidence.
          </p>
        </div>
      </div>
    </section>
  );
};
